import { useState } from "react";
import { Question, CaretDown } from "@phosphor-icons/react";

/** Reusable per-mode explainer — simple numbered steps + a points breakdown.
 *  Collapsible so it never crowds the screen on phones/tablets. */
export default function HowToPlay({ title = "How to play", steps = [], points = [], defaultOpen = false }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="nk-card overflow-hidden" data-testid="how-to-play">
      <button
        onClick={() => setOpen((o) => !o)}
        data-testid="how-to-play-toggle"
        className="w-full flex items-center justify-between px-4 sm:px-5 py-3.5 text-left hover:bg-nk-surface/40 transition-colors"
      >
        <span className="flex items-center gap-2 text-sm font-medium">
          <Question size={15} weight="duotone" className="text-nk-gold" />
          {title}
        </span>
        <CaretDown size={13} className={`text-white/55 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="px-4 sm:px-5 pb-5 space-y-5" data-testid="how-to-play-body">
          <ol className="space-y-3">
            {steps.map((s, i) => (
              <li key={i} className="flex gap-3">
                <span className="shrink-0 w-5 h-5 rounded-full bg-nk-gold/15 text-nk-gold text-[11px] font-mono flex items-center justify-center mt-0.5">
                  {i + 1}
                </span>
                <div className="min-w-0">
                  <p className="text-sm font-medium text-white">{s.title}</p>
                  <p className="text-xs text-white/55 mt-0.5 leading-relaxed">{s.desc}</p>
                </div>
              </li>
            ))}
          </ol>
          {points.length > 0 && (
            <div>
              <p className="eyebrow mb-2">Points breakdown</p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-1.5">
                {points.map((p, i) => (
                  <div key={i} className="flex items-center justify-between gap-2 border border-white/10 rounded-sm px-3 py-2">
                    <span className="text-xs text-white/55">{p.label}</span>
                    <span className="text-xs font-mono text-nk-gold shrink-0">{p.value}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
